'use client'
import React from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import Link from "next/link";
import LargeSwiperImage from '@components/LargeSwiperImage'


const TransportCardSlider = ({ title, description, btsStations, url, lang }) => {

    return (
        <section className='pl-3 mt-5 w-full'>
            {url ? (
                <Link href={`/${url}`}>
                    <h2 className='text-maincolor font-bold text-xl'>{title?.[lang]}</h2>
                </Link>
            ) : (
                <h2 className='text-maincolor font-bold text-xl'>{title?.[lang]}</h2>
            )}
            <p className="text-secondary">{description?.[lang]}</p>
            <div className='md:block hidden'>
                <Swiper
                    navigation={true}
                    modules={[Navigation]}
                    pagination={{
                        clickable: true,
                    }}
                    spaceBetween={16}
                    slidesPerView={4}
                    className="mt-2"
                >
                    {btsStations && btsStations.map((bts, index) => (
                        <SwiperSlide key={index}>
                            <LargeSwiperImage location={bts.id} type={'bts'} title={`${bts.type.toUpperCase()} ${bts.stationName}`} imageSrc={bts?.coverImage} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            <div className="md:hidden block flex-row flex-wrap">
                <Swiper
                    navigation={true}
                    modules={[Navigation]}
                    pagination={{
                        clickable: true,
                    }}
                    spaceBetween={16}
                    slidesPerView={1.5}
                    className="mt-2"
                >
                    {btsStations && btsStations.map((bts, index) => (
                        <SwiperSlide key={index}>
                            <LargeSwiperImage location={bts.id} type={'bts'} title={`${bts.type.toUpperCase()} ${bts.stationName}`} imageSrc={bts?.coverImage} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    )
}

export default TransportCardSlider